import React, {useEffect, useState} from 'react';
import { inject, observer } from "mobx-react";
import './Loyalty.css';
import _useTranslate from '../../hooks/_useTranslate';
import * as uniq from 'lodash/uniq';
import LoyaltyBar from './LoyaltyBar';
import { DateTime } from "luxon";
import { loyaltyProgress, loyaltyPaidOnce } from '../../utils/campaignTargeting';
import { DEFAULT_EMAIL } from "../../assets/globalConstants";

const Loyalty = ({feathersStore}) => {

let common = _useTranslate(feathersStore.language, "common");  

const [campaigns, setCampaigns] = useState(null);

useEffect(()=>{ 
  const asyncFn = async() => {
    const now = DateTime.now().setZone(feathersStore.timezone());
    const _coupons = await feathersStore.coupons();
    const _campaigns = _coupons?.filter(coupon =>  coupon?.active && (coupon?.completion > 0))
    let campaignsArray = [];
    let appliedCampaigns = (feathersStore.user?.loyaltyRewards || [])?.filter(loyalty => loyalty?.applied)?.map(c => c?.code);   
    //A cycle of a repeating campaign marks it paid as soon as it is HELD, spent or not - otherwise a
    //campaign switched back to once-only while a cycle is still unspent would draw its bar again
    //(accrual already refuses it, so the bar would promise a reward that never comes).
    const heldCycleCodes = (feathersStore.user?.loyaltyRewards || [])?.map(c => c?.code)?.filter(c => typeof c === 'string' && c.includes('-cycle-'));
    //HOISTED out of the loop: the query carries no campaign parameter, so fetching it per campaign
    //multiplied the customer's whole order history by the number of active campaigns - and since the
    //archive union it also spans ~14 months instead of ~2.
    const userOrders = _campaigns?.length > 0 ? await feathersStore.loyaltyOrdersPerUser() : [];
    for(let campaign of  _campaigns){
      if(campaign.repeatable || !loyaltyPaidOnce(campaign, [...appliedCampaigns, ...heldCycleCodes])){   
        let valid = false;   
        if(campaign?.endDate){
          if(DateTime.fromISO(campaign.endDate).endOf('day') > now)valid = true;
        }else{
          if(DateTime.fromISO(campaign.startDate).plus({days : campaign.duration}).endOf('day') > now)valid = true;
        }
        if(valid){

          let turnover;
          if(campaign.unit === 'Piece'){ //Bonus: progress is qualifying PAID pieces, not euros
            const scope = campaign.products || [];
            turnover = 0;
            for(const o of (userOrders || [])){
              if(o?.deletedOrder) continue;
              if(!(DateTime.fromMillis(o.createdAt) > DateTime.fromISO(campaign.startDate))) continue;
              for(const it of (o.items || [])){
                if(it?.product_free) continue;
                if(scope.includes(it.product_id)) turnover += +it.product_quantity || 0;
              }
            }
          }else{
            turnover = userOrders
            ?.filter(order => !order?.deletedOrder && DateTime.fromMillis(order.createdAt) > DateTime.fromISO(campaign.startDate))
              .map(order => order?.total || 0)
              .reduce((a, b) => +a + +b, 0);
          }
          turnover = loyaltyProgress(campaign, turnover);   //repeating: progress towards the NEXT reward
          Object.assign(campaign, {turnover});
          campaignsArray.push(campaign);
        }
      }
    }
    const groupedCampaigns = groupCampaigns(campaignsArray);
    setCampaigns(groupedCampaigns);
  }  
  //Every visitor is auto-logged into ONE shared guest account, so for a guest this query returns
  //the whole tenant's guest order history - other people's orders, with their delivery details on
  //them. A loyalty bar for the shared guest is meaningless anyway.
  feathersStore?.isAuthenticated && feathersStore?.user?.email !== DEFAULT_EMAIL && asyncFn();
},[feathersStore?.isAuthenticated]);

const groupCampaigns = campaignsArray => {
  let returnArray = [];
  //Campaigns sharing a startDate share one bar - but a REPEATING one measures progress to its own
  //next reward, so it cannot share a single turnover with anything else: give it its own bar.
  const groupKey = cam => cam.repeatable ? `${cam.startDate}#${cam.code}` : cam.startDate;
  let uniqueDates = uniq(campaignsArray.map(groupKey));
  for(let date of uniqueDates){
    let arr = campaignsArray?.filter(c => groupKey(c) === date);   
    arr.sort((a,b) => a.completion - b.completion)
    const item = {
      startDate: arr[0]?.startDate,
      wayPoints: arr
    }
    returnArray.push(item) 
  }
  return returnArray.sort((a, b) => 
    a?.endDate ? DateTime.fromISO(a.endDate) : DateTime.fromISO(a.startDate).plus({days : a.duration}).endOf('day') 
      <  b?.endDate ? DateTime.fromISO(b?.endDate) : DateTime.fromISO(b.startDate).plus({days : b.duration}).endOf('day'));
}

return(  
  <>
    {campaigns?.length > 0 &&<div className="loyalty-container">
      <div className="loyalty-title">{common.loyaltyMoto}</div>
      {  campaigns?.map((campaign, index) => (
        <LoyaltyBar 
          key={index}
          endsIn={common.endsIn}
          days={common.days}
          campaign = {campaign}
        />
      ))
    }  
    </div>}
  </>
)

}

export default inject('feathersStore')(observer(Loyalty));